(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3760"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3760"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
// Importando Swiper e os estilos necessários

var $9qak9 = parcelRequire("9qak9");
window.$ = window.jQuery = (0, (/*@__PURE__*/$parcel$interopDefault($9qak9)));
if ($(window).width() < 575) $(function() {
    let cards = gsap.utils.toArray(".data-info-wrapper");
    let stickDistance = 0;
    let firstCardST = ScrollTrigger.create({
        trigger: cards[0],
        start: "center center"
    });
    let lastCardST = ScrollTrigger.create({
        trigger: cards[cards.length - 1],
        start: "center center"
    });
    cards.forEach((card, index)=>{
        var scale = 1 - (cards.length - index) * 0.045;
        let scaleDown = gsap.to(card, {
            scale: scale,
            "transform-origin": '"50% ' + (lastCardST + stickDistance) + '"'
        });
        ScrollTrigger.create({
            trigger: card,
            start: "top top",
            end: ()=>lastCardST.start + stickDistance,
            pin: true,
            markers: false,
            pinSpacing: false,
            ease: "none",
            animation: scaleDown,
            toggleActions: "restart none none reverse"
        });
    });
});

})();
//# sourceMappingURL=index.9e384e40.js.map
